// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { PortalTab } from "src/modules/pages/jsx/_switcher.jsx";
import { ProgramContent } from "src/modules/my-program/jsx/program-content.jsx";
import { FeeStatus } from "src/modules/finances-inner/jsx/fee-status.jsx"
import { sq_personalise } from 'src/lib/personalisation.js';


// Stateful components

export class PageTabsList extends React.Component{

    //
    // Lifecycle 
    //
    constructor(props) {
        super(props);

        this.state = {
            'active_tab': 0,
            'mobile_tabs_visible': false
        };

        // Binds
        this.changeActiveTab = this.changeActiveTab.bind(this);
        this.changeTabVisibility = this.changeTabVisibility.bind(this);
    }

    componentDidMount(){
        var this_component = this;
        this_component.setActiveTab();
    }

    componentDidUpdate(prev_props, prev_state) {
        var this_component = this;

        // New Current Page
        var current_page = this_component['props']['current_page'];
        if(current_page !== prev_props['current_page']) {
            this_component.setActiveTab();
        }
    }


    //
    // Events
    //

    changeActiveTab(event) {
        event.preventDefault();

        var this_component = this;
        var target = event['target'];
        var tab_slug = target.getAttribute('data-slug');
        var tab_index = parseInt(target.getAttribute('data-index'));

        // Update the URL
        this_component.updateHashLocation(tab_slug);

        this_component.setActiveTab(tab_index);
        
        this_component.setState({
            'mobile_tabs_visible': false
        });
    }

    updateHashLocation(tab_slug) {
        var this_component = this;
        var current_page = this_component['props']['current_page'];

        // Change URL
        var current_hash = window.location.hash.replace(/\/$/, '')
        var ia_count = current_hash.split('/');;
        var new_hash = '';

        if(ia_count.length === 2) {
            new_hash = current_hash + '/' + tab_slug;
        } else {
            new_hash = current_hash.replace(current_page, tab_slug);
        }
        
        window.location.hash = new_hash;
    }

    changeTabVisibility(event) {
        event.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var viewport = portal_context['viewport'];

        if(viewport < 3) {
            var mobile_tabs_visible = this_component['state']['mobile_tabs_visible'];

            this_component.setState({
                'mobile_tabs_visible': !mobile_tabs_visible
            });
        }
    }


    //
    // Functions
    //

    compareHashLocation(tab_slug) {
        var current_hash = window.location.hash.split('/');

        
    }

    getExtraTabs() {
        var this_component = this;
        var data_source = this_component['props']['extra_tabs'];

        var extra_tabs = [];

        switch(data_source) {
            case 'programs':
                extra_tabs = this_component.getProgramTabs();
                break;
            case 'finances':
                extra_tabs = this_component.getFinanceTabs();
                break;
        }

        return extra_tabs;
    }

    getProgramTabName(program) {
        var name = program['name'];

        // Add program code to tab name
        if (typeof(program['code']) !== 'undefined') {
            name += ' (' + program['code'] + ')';
        }

        // Add campus to tab name
        if (typeof(program['campusName']) !== 'undefined') {
            name +=  ' ' + program['campusName'].split(' Campus')[0];
        }

        return name;
    }

    getProgramTabs() {
        var this_component = this;

        // Course data
        var my_courses_data = squiz.fn.getStorage('getmycourses', 'session', 'json');
        var my_programs = my_courses_data['data']['programs'];

        // Add program indexes and custom tab name to data so tabs can read it
        my_programs.forEach(function(program, program_index){
            program['program_index'] = program_index;
            program['name'] = this_component.getProgramTabName(program);
        });

        return my_programs;
    }

    getFinanceTabs() {
        var fees_v2= squiz.fn.getStorage('getmyfeesv2', 'session', 'json');

        if (fees_v2 && fees_v2['data']) {
            var programs = fees_v2['data']['feeStatus'];

            // Add program indexes to data so tabs can read it
            programs.forEach(function(program, program_index){
                program['program_index'] = program_index;
                program['name'] = program['programDescription'];
            });

            return programs;
        }

        return [];
    }

    getPageTabs() {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        // Get current page
        var current_page = this_component['props']['current_page'];

        var page_data = helpers.getPageBySlug(current_page);
        var ia_level = page_data['ia_level'];

        // Get all tabs
        var pages_as_tabs = null;

        if(ia_level === 1) {
            pages_as_tabs = page_data['children'];
        } else {
            var parent_page = page_data['parent'];
            var parent_data = helpers.getPageBySlug(parent_page);
            pages_as_tabs = parent_data['children'];
        }

        return pages_as_tabs;
    }

    setActiveTab(clicked_tab_index) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var active_tab = this_component['state']['active_tab'];
        var current_page = this_component['props']['current_page'];

        var page_data = helpers.getPageBySlug(current_page);
        var ia_level = page_data['ia_level'];
        
        // Get all tabs
        var all_tabs = this_component.getAllTabs();

        if(typeof(clicked_tab_index) !== 'undefined') {
            // User has clicked a tab
            if(clicked_tab_index !== active_tab) {
                this_component.setState({
                    'active_tab': clicked_tab_index
                });
            }
        } else if (ia_level === 2) {
            // User has landed on a Level 2 tab
            var active_tab_index = 0;
            all_tabs.forEach(function(tab, index) {
                if (tab['slug'] === current_page) {
                    active_tab_index = index;
                }
            });
            this_component.setState({
                'active_tab': active_tab_index
            });
        } else {
            // User has landed on a Level 1 page that has tabs
            var active_tab_data = all_tabs[active_tab];

            if (active_tab_data) {
                var active_tab_slug = active_tab_data['slug'];

                // Check if the active tab has its own path
                if(typeof(active_tab_slug) !== 'undefined') {

                    // Check if the active tab belongs to the active page
                    if(current_page !== active_tab_slug) {
                        
                        // The active tab in this scenario should always be 0
                        if(active_tab !== 0) {
                            // Reset the tabs
                            this_component.setState({
                                'active_tab': 0
                            });

                            // Get initial tab slug
                            var first_tab_data = all_tabs[0];
                            var first_tab_slug = first_tab_data['slug'];

                            if(typeof(first_tab_slug) !== 'undefined') {
                                // Update the active page to match the active tab
                                this_component.updateHashLocation(first_tab_slug);
                            }
                        } else {
                            // Update the active page to match the active tab
                            this_component.updateHashLocation(active_tab_slug);
                        }                    
                        
                    }
                }
            }
            
        }
    }
    
    getAllTabs() {
        var this_component = this;
        var portal_context = this_component['context'];
        var user_personalisation = portal_context['user_personalisation'];
        
        // Get additional tabs
        var extra_tabs = this_component.getExtraTabs();

        // Get all page tabs
        var pages_as_tabs = this_component.getPageTabs();

        // Combine tabs
        var all_tabs = extra_tabs.concat(pages_as_tabs);
        all_tabs = sq_personalise.fn.filterItems(all_tabs, user_personalisation['attributes']);

        return all_tabs;
    }

    getTabsForMobile() {
        var this_component = this;
        var active_tab_index = this_component['state']['active_tab'];
        var page_tabs = this_component.getAllTabs();
        var mobile_tabs = [];
        var active_tab;

        page_tabs.forEach(function(tab, tab_index) {
            tab['list_index'] = tab_index;

            if(tab_index !== active_tab_index) {
                // Add normal tab to the list keeping order
                mobile_tabs.push(tab);
            } else {
                active_tab = tab;
            }
        });

        return {
            'active_tab': active_tab,
            'other_tabs': mobile_tabs
        };
    }


    //
    // Render
    //

    renderAllTabs() {
        var this_component = this;
        var portal_context = this_component['context'];
        var viewport = portal_context['viewport'];

        if(viewport < 3) {
            return this_component.renderMobileTabs();
        } else {
            return this_component.renderDesktopTabs();
        }
    }

    renderTab(tab_data) {
        var tab_content = tab_data['tab_content'];
        var item_class = tab_data['tab_class'];
        var tab_index = tab_content['list_index'];
        var clickHandler = tab_data['clickHandler'];
        var tab_name = tab_content['name'];
        var tab_slug = tab_content['slug'];
        var is_current_mobile = tab_data['is_current_mobile'] ? true : false;

        if(typeof(tab_slug) === 'undefined') {
            tab_slug = '';
        }

        var aria_label = `Go to ${tab_name}`;
        if (is_current_mobile) {
            aria_label = 'Toggle My Program navigation';
        }

        return (
            <li key={tab_index} className={item_class}>
                {clickHandler ? (
                    <button className="page-tabs__button" data-slug={tab_slug} data-index={tab_index} onClick={clickHandler} aria-label={aria_label}>{tab_name}</button>
                ) : (
                    <button className="page-tabs__button" disabled>{tab_name}</button>
                )}  
            </li>
        );
    }

    renderMobileTabs() {
        var this_component = this;
        var mobile_tabs_visible = this_component['state']['mobile_tabs_visible'];
        var mobile_tabs = this_component.getTabsForMobile();
        var list_class = 'page-tabs__list';

        var is_one_tab = false;
        if (mobile_tabs) {
            if (mobile_tabs['active_tab'] && mobile_tabs['other_tabs'].length < 1) {
                is_one_tab = true;
            }
        }

        // Render active tab
        var active_tab = null;
        var mobile_active_tab = mobile_tabs['active_tab'];

        if (typeof(mobile_active_tab) !== 'undefined') {

            var click_handler = !is_one_tab ?  this_component.changeTabVisibility : null;

            var tab_class = 'page-tabs__item page-tabs__item--current';
            if (!is_one_tab) {
                tab_class += ' page-tabs__item--toggle';
            }

            var active_tab_data = {
                'tab_class': tab_class,
                'tab_content': mobile_active_tab,
                'clickHandler': click_handler,
                'is_current_mobile': true
            };
    
            active_tab = this_component.renderTab(active_tab_data);
        }

        // Render other tabs
        var rendered_tabs = null;

        if(mobile_tabs_visible) {
            list_class += ' page-tabs__list--open';

            rendered_tabs = mobile_tabs['other_tabs'].map(function(tab, tab_index) {
                var tab_data = {
                    'tab_class': 'page-tabs__item',
                    'tab_content': tab,
                    'clickHandler': this_component.changeActiveTab
                };

                return this_component.renderTab(tab_data);
            });
        }

        return (
            <ul className={list_class}>
                {active_tab}
                {rendered_tabs}
            </ul>
        );
    }

    renderDesktopTabs() {
        var this_component = this;
        var active_tab_index = this_component['state']['active_tab'];
        var page_tabs = this_component.getAllTabs();

        var rendered_tabs = page_tabs.map(function(tab, tab_index) {
            var tab_class = 'page-tabs__item';
            tab['list_index'] = tab_index;

            if(tab_index === active_tab_index) {
                tab_class += ' page-tabs__item--current';
            }

            var tab_data = {
                'tab_class': tab_class,
                'tab_content': tab,
                'clickHandler': this_component.changeActiveTab
            };

            return this_component.renderTab(tab_data);
        });

        return (
            <ul className='page-tabs__list'>
                {rendered_tabs}
            </ul>
        );
    }

    renderActiveTab() {
        var this_component = this;
        var active_tab_index = this_component['state']['active_tab'];
        var page_tabs = this_component.getAllTabs();

        // Reset to first tab if index doesn't exist (eg. cancelling simulation)
        if (active_tab_index >= page_tabs.length) {
            active_tab_index = 0;
        }

        var active_tab = page_tabs[active_tab_index];
        var tab_content = null;

        if (active_tab) {
            if(typeof(active_tab['slug']) !== 'undefined') {
                // Content Page
                tab_content = <PortalTab page={active_tab['slug']} />
            
            } else {
                var data_source = this_component['props']['extra_tabs'];
                
                // Extra tabs
                switch(data_source) {
                    case 'programs':
                        tab_content = <ProgramContent index={active_tab['program_index']} />
                        break;
                    case 'finances':
                        tab_content = <FeeStatus index={active_tab['program_index']} />
                        break;
                }
                
            }
            
            return (
                <div className="page-tabs__content page-tabs__content--open">
                    {tab_content}
                </div>
            );
        }
        
        return null;
    }

    render() {
        var this_component = this;
        var all_tabs = this_component.renderAllTabs();
        var content_tab = this_component.renderActiveTab();

        if (all_tabs || content_tab) {
            return (
                <div className="page-tabs__wrapper" data-ga-label="Tabs">
                    {all_tabs}
                    {content_tab}
                </div>
            );
        }
        
        return null;
    }

};

PageTabsList.contextType = PortalContext;
